// PerformCustom data — all demo data removed.
// These exports are intentionally empty so the UI renders empty states.

export const GAMES = [];
export const COACHES = [];
export const OFFERINGS = [];
export const EVENTS = [];
export const GUIDES = [];
export const COMMUNITIES = [];
export const REVIEWS = [];
export const NOTIFICATIONS = [];
export const CATEGORIES = ["All"];
export const PROGRESS_DATA = [];
export const REVENUE_DATA = [];
